import { ResetPasswordFormErrorsJSON } from '../models/reset-password-form';

export const formResetPasswordErrors: ResetPasswordFormErrorsJSON = {
    password: [
        {
            code: 'required',
            message: 'Required field',
        },
        {
            code: 'minlength',
            message: 'Minimun 8 characters',
        },
    ],
    confirmPassword: [
        {
            code: 'required',
            message: 'Required field',
        },
        {
            code: 'minlength',
            message: 'Minimun 8 characters',
        },
    ],
    form: [
        {
            code: 'mismatch',
            message: "The password doesn't match, review your information",
        },
    ],
};
